export default {
  feedEmOrderLines: [],
  feedEmOrderLine: undefined,
};
